<h2 mat-dialog-title>
  {{data.title}}
</h2>

<mat-dialog-content>

  <ng-container *ngIf="data.type === 'custom'">
    <ng-container *ngTemplateOutlet="data.options.content"></ng-container>
  </ng-container>

  <mat-form-field *ngIf="data.type === 'prompt' && value" appearance="outline" class="f-width">
    <mat-label *ngIf="data.options.label">
      {{data.options.label}}
    </mat-label>

    <input matInput
      name="value"
      [formControl]="value"
     [type]="data.options.type"
     [placeholder]="data.options.placeholder">

    <mat-icon *ngIf="data.options.matSuffixIcon" matSuffix>
      {{data.options.matSuffixIcon}}
    </mat-icon>

    <mat-icon *ngIf="data.options.matPrefixIcon" matPrefix>
      {{data.options.matPrefixIcon}}
    </mat-icon>

    <!--
      <mat-hint>Hint</mat-hint>
    -->
  </mat-form-field>


  <div *ngIf="data?.icon?.name">
    <div>
      <mat-icon style="font-size: 40px; height: 40px; width:40px" color="primary">
        {{data.icon.name}}
      </mat-icon>
      <br><br>
    </div>
  </div>


  <div *ngIf="data?.options?.text">
    <div class="mat-h3" [innerHTML]="data?.options?.text">

    </div>
  </div>



</mat-dialog-content>

<mat-dialog-actions *ngIf="data.type !== 'custom' || data?.options?.footer">
  <ng-container *ngIf="data.type === 'custom' ">
    <ng-container *ngTemplateOutlet="data?.options?.footer"></ng-container>
  </ng-container>

  <ng-container *ngIf="data.type === 'alert'">
    <button type="button" color="primary" mat-stroked-button mat-button mat-dialog-close>
      Fermer
    </button>
  </ng-container>

  <ng-container *ngIf="data.type === 'prompt'">
    <button type="button" mat-button mat-dialog-close>
      Fermer
    </button>

    <button [disabled]="value.errors" type="button" mat-button [mat-dialog-close]="value.value">
      Valider
    </button>
  </ng-container>


  <ng-container *ngIf="data.type === 'confirm'">
    <button mat-stroked-button type="button" color="primary" mat-button mat-dialog-close>
      Annuler
    </button>

    <button mat-raised-button color="primary" type="button" mat-button [mat-dialog-close]="true">
      <ng-container *ngIf="data.options?.confirmTextButton">
        {{data.options.confirmTextButton}}
      </ng-container>
      <ng-container *ngIf="!data.options?.confirmTextButton">
        Valider
      </ng-container>
    </button>
  </ng-container>
</mat-dialog-actions>
